import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'tss-react/mui';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { CircularProgress, IconButton, MenuItem, Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import Select from '@mui/material/Select';

import Utils from '../utils/Utils';

const grey500 = grey['500'];

const styles = {
    bar: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        fontSize: '12px',
        fontWeight: 'normal'
    }
};

class NumericalServerPagingBar extends React.Component {
    static propTypes = {
        skip: PropTypes.number.isRequired,
        size: PropTypes.number.isRequired,
        total: PropTypes.number
    };

    render() {
        let { skip, size, total, onPrevClick, onNextClick, onRowsCountChange, classes, isLoading } = this.props;
        let to = skip + size;
        total = total || 0;
        if (to > total) {
            to = total;
        }

        const isMobile = Utils.isMobile();

        return (
            <Toolbar className={classes.bar}>
                {isLoading && (
                    <Box mr={2}>
                        <CircularProgress size={24} />
                    </Box>
                )}

                {!isMobile && (
                    <React.Fragment>
                        <span>Rows per page:</span>
                        <Select
                            value={size}
                            disabled={isLoading}
                            style={{ color: grey500, width: 'auto', marginLeft: '8px' }}
                            onChange={(e) => onRowsCountChange(e.target.value)}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={30}>30</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={200}>200</MenuItem>
                        </Select>
                    </React.Fragment>
                )}

                <IconButton
                    disabled={isLoading}
                    onClick={() => onPrevClick(skip - size <= 0 ? 0 : skip - size)}
                    size="large"
                >
                    <KeyboardArrowLeft />
                </IconButton>

                {isMobile ? (
                    <span>{skip + 1}</span>
                ) : (
                    <span>
                        {skip + 1}-{to} of {total}
                    </span>
                )}

                <IconButton
                    disabled={isLoading}
                    onClick={() => onNextClick(skip + size > total ? total : skip + size)}
                    size="large"
                >
                    <KeyboardArrowRight />
                </IconButton>
            </Toolbar>
        );
    }
}

export default withStyles(NumericalServerPagingBar, styles);
